import React from "react"
import {
  eventsItemImg,
  eventsItemDate,
  eventsItemDateFrom,
  eventsItemDateTo,
  eventsItemTaxoLine,
  eventsItemTaxo,
  eventsItemTitle,
  editButton,
} from "../agenda.module.scss"
import {
  EventsItemImg,
  Taxo,
  Title,
  StyledDate,
} from "./evenement-content-styled"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import { summaryLength } from "gatsby-theme-blank/src/constants"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const EvenementContent = ({ evenement }) => (
  <>
    <EditButton
      addedClass={editButton}
      link={"/node/" + evenement.drupal_internal__nid + "/edit"}
    />
    <TransitionFade link={evenement.path.alias} tabIndex={"0"}>
      <div>
        <EventsItemImg className={eventsItemImg}>
          {evenement.relationships.field_image_event?.localFile && (
            <div>
              <NonStretchedImage
                {...evenement.relationships.field_image_event.localFile}
                ariaHidden={true}
              />
            </div>
          )}
        </EventsItemImg>
        <StyledDate className={eventsItemDate}>
          {!evenement.fields.formatted_field_date_de_fin ? (
            <span className={eventsItemDateFrom}>
              Le {evenement.fields.formatted_field_date_de_debut}
            </span>
          ) : (
            <>
              <span className={eventsItemDateFrom}>
                Du {evenement.fields.formatted_field_date_de_debut}
              </span>
              <span className={eventsItemDateTo}>
                {" "}
                au {evenement.fields.formatted_field_date_de_fin}
              </span>
            </>
          )}
        </StyledDate>
        <Title className={eventsItemTitle}>{evenement.title}</Title>
        {evenement.body && (
          <p
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(evenement.body, summaryLength),
            }}
          />
        )}
        {evenement.relationships.field_taxonomie_thematique?.length > 0 && (
          <div className={eventsItemTaxoLine}>
            <span>Thématique :</span>
            {evenement.relationships.field_taxonomie_thematique.map((node) => (
              <Taxo key={node.drupal_id} className={eventsItemTaxo}>
                {node.name}
              </Taxo>
            ))}
          </div>
        )}
      </div>
    </TransitionFade>
  </>
)

EvenementContent.propTypes = {
  evenement: PropTypes.object.isRequired,
}

export default EvenementContent
